function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "bus@2x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "All-other-redesigns",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Listing-detail-view-(mover)",
  transform: "translate(-455.000000, -1256.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Location-block",
  transform: "translate(53.000000, 1106.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bus",
  transform: "translate(402.000000, 150.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Combined-Shape-Copy-13",
  fill: "#DF6E4F",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.4,14.7561404 L6.4,8.00175439 C6.4,5.6377193 8.86125,5.3 11.9,5.3 C14.93875,5.3 17.4,5.6377193 17.4,8.00175439 L17.4,14.7561404 C17.4,15.3539035 17.131875,15.8841228 16.7125,16.255614 L16.7125,17.4578947 C16.7125,17.829386 16.403125,18.1333333 16.025,18.1333333 L15.3375,18.1333333 C14.9559375,18.1333333 14.65,17.829386 14.65,17.4578947 L14.65,16.7824561 L9.15,16.7824561 L9.15,17.4578947 C9.15,17.829386 8.8440625,18.1333333 8.4625,18.1333333 L7.775,18.1333333 C7.396875,18.1333333 7.0875,17.829386 7.0875,17.4578947 L7.0875,16.255614 C6.668125,15.8841228 6.4,15.3539035 6.4,14.7561404 Z M8.80625,15.4315789 C9.376875,15.4315789 9.8375,14.9790351 9.8375,14.4184211 C9.8375,13.857807 9.376875,13.4052632 8.80625,13.4052632 C8.235625,13.4052632 7.775,13.857807 7.775,14.4184211 C7.775,14.9790351 8.235625,15.4315789 8.80625,15.4315789 Z M14.99375,15.4315789 C15.564375,15.4315789 16.025,14.9790351 16.025,14.4184211 C16.025,13.857807 15.564375,13.4052632 14.99375,13.4052632 C14.423125,13.4052632 13.9625,13.857807 13.9625,14.4184211 C13.9625,14.9790351 14.423125,15.4315789 14.99375,15.4315789 Z M16.025,11.3789474 L16.025,8.00175439 L7.775,8.00175439 L7.775,11.3789474 L16.025,11.3789474 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
})))));

var SvgBus = function SvgBus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bus.d7f56c88.svg";
export { ForwardRef as ReactComponent };